"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (arr, key) {
  var number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var selected = [];
  arr.forEach(function (val) {
    if (val.value) selected.push(val[key]);
  });
  return number ? selected[0] : selected;
};